import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { mapState } from 'vuex';
import ClickOutside from 'vue-click-outside';
import config from '@/config';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faCog,
  faUser,
  faBell,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

import contentHeader from '@/components/ContentHeader/ContentHeader.vue';
import Hint from '@/components/Hint/Hint.vue';
import NotificationsDropdown from '@/components/notifications/NotificationsDropdown/NotificationsDropdown.vue';
import toggler from '@/components/Toggler/Toggler.vue';
import UserNav from '@/components/ui/dropdowns/UserNav/UserNav.vue';

library.add(faCog, faBell, faSignOutAlt, faUser);
dayjs.extend(customParseFormat);

export default {
  name: 'navbar',

  data() {
    return {
      togglerIsVisible: window.innerWidth <= 768,
      usernavVisible: false,
      notificationsVisible: false
    };
  },

  created() {
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    ...mapState({
      userName: state => state.user.profile.name,
      isFullView: state => state.navigation.fullView,
      isAdmin: state => state.user.profile.isAdmin,
      balance: state => state.billing.balance,
      currency: state => state.billing.currency,
      plan: state => state.billing.plan,
      userTarif: state => state.billing.userBilling.tariff,

      notifications: state => state.notifications.notifications,
      sortedNotifications: state => state.notifications.sortedNotifications,
      notificationsPage: state => state.notifications.notificationsPage,
      isNotificationsLoading: state =>
        state.notifications.isNotificationsLoading
    }),

    planIsActive() {
      const expirationDate = dayjs(
        this.plan.expiresByDate,
        config.dateOutputFormat
      );
      const nowDate = dayjs(new Date());
      return nowDate.isBefore(expirationDate);
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    notViewedNotificationsCount() {
      return this.notifications.filter(notification => {
        return notification.viewed !== true && notification.viewed !== 1;
      }).length;
    },

    notViewedNotificationsNotify() {
      return this.notViewedNotificationsCount > 9
        ? '9+'
        : this.notViewedNotificationsCount;
    },

    notificationsCount() {
      return this.notifications && this.notifications.length;
    }
  },

  methods: {
    onClickToggleUsernav() {
      this.$refs.usernav.toggle();
      this.usernavVisible = !this.usernavVisible;
    },

    hideUsernav() {
      this.$refs.usernav.hide();
      this.usernavVisible = false;
    },

    onResize() {
      this.togglerIsVisible = window.innerWidth <= 768;
    },

    onClickToggleNotifications() {
      this.notificationsVisible = !this.notificationsVisible;
    },

    hideNotifications() {
      this.notificationsVisible = false;
    }
  },

  components: {
    FontAwesomeIcon,
    ClickOutside,
    NotificationsDropdown,
    contentHeader,
    toggler,
    Hint,
    UserNav
  },

  directives: {
    ClickOutside
  }
};
